export default "__VITE_PUBLIC_ASSET__c18d98ff__"